import { render } from "./DriverCapacityPage.vue?vue&type=template&id=8880ce78&scoped=true"
import script from "./DriverCapacityPage.vue?vue&type=script&lang=js"
export * from "./DriverCapacityPage.vue?vue&type=script&lang=js"

import "./DriverCapacityPage.vue?vue&type=style&index=0&id=8880ce78&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8880ce78"]])

export default __exports__